<template>
    <ion-page>
        <ion-header :translucent="true">
            <ion-toolbar>
                <ion-buttons slot="start">
                    <ion-button @click="closeModal()">
                        <ion-icon slot="start" :icon="arrowBackOutline" color="white"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-title color="white">Nuova nota spesa</ion-title>
            </ion-toolbar>
        </ion-header>

        <ion-content :fullscreen="true">
            <div class="page_content">
                <form @submit.prevent="creaSpesa()">
                    <ion-list class="fields">
                        <!-- Data inizio -->
                        <ion-item lines="none" class="ion-no-padding">
                            <div class="field">
                                <div class="field_title">
                                    Data
                                    <ion-text color="danger"><strong>*</strong></ion-text>
                                </div>
                                <div class="value">
                                    <ion-datetime
                                        name="date_start"
                                        display-format="DD/MM/YYYY"
                                        picker-format="DD/MM/YYYY"
                                        min="2026"
                                        max="2099"
                                        slot="end"
                                        doneText="OK"
                                        cancelText="Annulla"
                                        v-model="spesa.data"
                                    ></ion-datetime>
                                </div>
                            </div>
                        </ion-item>

                        <!-- prezzo -->
                        <ion-item lines="none" class="field ion-no-padding">
                            <div class="field">
                                <div class="field_title">
                                    Importo
                                    <ion-text color="danger"><strong>*</strong></ion-text>
                                </div>
                                <div class="value">
                                    <ion-input type="number" min="0" step="any" v-model="spesa.importo" placeholder="Importo della spesa"> </ion-input>
                                </div>
                            </div>
                        </ion-item>

                        <!-- prezzo -->
                        <ion-item lines="none" class="field ion-no-padding">
                            <div class="field">
                                <div class="field_title">
                                    Categoria
                                </div>
                                <ion-select name="tipologia" interface="action-sheet" cancel-text="Annulla" ok-text="Conferma" v-model="spesa.categoria">
                                    <ion-select-option
                                        v-for="category in categories"
                                        :key="category.nota_spese_categoria_id"
                                        :value="category.nota_spese_categoria_id"
                                    >
                                        {{ `${category.nota_spese_categoria_value}` }}
                                    </ion-select-option>
                                </ion-select>
                            </div>
                        </ion-item>

                        <!-- Descrizione -->
                        <ion-item lines="none" class="field ion-no-padding">
                            <div class="field">
                                <div class="field_title">Descrizione</div>
                                <div class="value">
                                    <ion-textarea
                                        type="text"
                                        rows="3"
                                        v-model="spesa.descrizione"
                                        placeholder="Inserisci la descrizione della spesa effettuata"
                                    >
                                    </ion-textarea>
                                </div>
                            </div>
                        </ion-item>

                        <ion-item v-if="userPhoto.length != 0" lines="none" class="field ion-no-padding">
                            <div class="field">
                                <div v-for="photo in userPhoto" :key="photo">
                                    <ion-img :src="photo.tmp_src" class="img_photo"></ion-img>
                                    <div @click="showActionSheet(photo)" class="img_action">
                                        <ion-icon :icon="trash"></ion-icon>
                                    </div>
                                </div>
                            </div>
                        </ion-item>

                        <ion-item lines="none" class="field ion-no-padding">
                            <div class="field">
                                <button class="btn_foto" type="button" ref="refFotoButton" @click="triggerCameraButton()" :disabled="sendingData">
                                    Aggiungi foto
                                </button>
                                <input type="file" id="cameraInput" accept="image/*" style="display: none;" ref="refInputButton" @change="getPhoto($event)" />
                            </div>
                        </ion-item>

                        <div class="actions">
                            <!--  <button class="btn_foto" type="button" @click="showActionSheetPhotos()">
                                Aggiungi foto
                            </button> -->
                            <button type="submit" :disabled="sendingData" class="btn_richiesta">
                                <span v-if="!sendingData">Inserisci nota spesa</span>
                                <span v-else>Salvataggio in corso</span>
                            </button>
                        </div>
                    </ion-list>
                </form>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
import {
    IonPage,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonButton,
    modalController,
    IonList,
    IonItem,
    IonDatetime,
    IonTextarea,
    IonText,
    IonInput,
    IonIcon,
    IonImg,
    IonSelect,
    IonSelectOption,
    actionSheetController,
} from "@ionic/vue";
import { arrowBackOutline, camera, images, close, trash } from "ionicons/icons";

import { defineComponent, ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";

import { LOCALSTORAGE_KEY } from "@/custom_config";

import moment from "moment";
import imageToBase64 from "image-to-base64/browser";

import { openToast } from "@/services/toast";
import apiSpese from "@/services/spese";
import { usePhotoGallery, UserPhoto } from "@/services/usePhotoGallery";

export default defineComponent({
    name: "ModalNuovaNotaSpesa",
    components: {
        IonPage,
        IonContent,
        IonHeader,
        IonTitle,
        IonToolbar,
        IonButtons,
        IonButton,
        IonList,
        IonItem,
        IonDatetime,
        IonTextarea,
        IonText,
        IonInput,
        IonIcon,
        IonImg,
        IonSelect,
        IonSelectOption,
    },
    setup(props, context) {
        const start_date = new Date();
        const end_hour = new Date();
        const start_hour = new Date(end_hour);
        start_hour.setHours(start_hour.getHours() + 1);
        end_hour.setHours(start_hour.getHours() + 2);

        const dipendenteID = JSON.parse(localStorage.getItem(`${LOCALSTORAGE_KEY}`)).dipendenti_id;

        const spesa = reactive({
            data: start_date.toISOString(),
            importo: "0",
            categoria: null,
            descrizione: null,
        });

        // Disabled button flag
        const sendingData = ref(false);

        const successResponse = ref(false);

        const { userPhoto, takePhoto, deletePhoto, pickPhotos } = usePhotoGallery();

        let photoToSave = null;

        /**
         * ! Close modal after form data submit
         */
        async function closeModalOnSubmit(successResponse, res) {
            if (successResponse.value) {
                await modalController.dismiss(res);
            } else {
                await modalController.dismiss();
            }
        }

        /**
         * ! Get cateogrie
         */
        const categories = ref([]);
        async function loadCategory() {
            const res = await apiSpese.getCategorieSpese();

            if (res.status === 200 && res.data.status === 0) {
                categories.value = res.data.data;
            } else {
                openToast("Si è verificato un errore durante la richiesta delle categorie", "toast_danger");
            }
        }
        loadCategory();

        /**
         * ! Handle camera and device selection photos
         */
        const showActionSheetPhotos = async () => {
            const actionSheet = await actionSheetController.create({
                header: "Scegli modalità di caricamento",
                buttons: [
                    {
                        text: "Fotocamera",
                        icon: camera,
                        handler: () => {
                            deletePhoto(); //cancella eventuale foto caricata precedentemente
                            takePhoto();
                        },
                    },
                    {
                        text: "Galleria",
                        icon: images,
                        handler: () => {
                            deletePhoto(); //cancella eventuale foto caricata precedentemente
                            pickPhotos();
                        },
                    },
                    {
                        text: "Annulla",
                        icon: close,
                        role: "cancel",
                        handler: () => {
                            // Nothing to do, action sheet is automatically closed
                        },
                    },
                ],
            });
            await actionSheet.present();
        };

        /**
         * ! Handle delete single photo
         */
        const showActionSheet = async (photo) => {
            const actionSheet = await actionSheetController.create({
                header: "Foto",
                buttons: [
                    {
                        text: "Elimina",
                        role: "destructive",
                        icon: trash,
                        handler: () => {
                            //deletePhoto(photo);
                            deletePhoto();
                            photoToSave = null;
                        },
                    },
                    {
                        text: "Annulla",
                        icon: close,
                        role: "cancel",
                        handler: () => {
                            // Nothing to do, action sheet is automatically closed
                        },
                    },
                ],
            });
            await actionSheet.present();
        };

        /**
         * !  Iterates all photos, convert to base64 and return.
         */
        const conversioneFoto = async (userPhoto) => {
            const requests = userPhoto.map((photo) => {
                return imageToBase64(photo.webviewPath) // Path to the image
                    .then((response) => {
                        //console.log(response);
                        const fileName = photo.filepath;
                        //fileName = fileName.substring(0, fileName.length - 5);
                        //console.log(str);
                        const foto = {
                            name: fileName,
                            data: response,
                        };
                        return foto;
                    })
                    .catch((error) => {
                        console.error(error);
                        sendingData.value = true;
                    });
            });
            return Promise.all(requests); // Waiting for all the requests to get resolved.
        };

        /**
         * ! Handle close modal by clicking on Chiudi button
         */
        const closeModal = () => {
            modalController.dismiss();
        };

        /**
         *
         * ! Get photo from camera or gallery
         *
         */
        const refFotoButton = ref(null);
        const refInputButton = ref(null);
        const triggerCameraButton = () => {
            if (refFotoButton.value) {
                refInputButton.value.click();
            }
        };

        const currentBase64Photo = ref(null);
        async function getPhoto(event) {
            const file = event.target.files[0];

            if (file) {
                const reader = new FileReader();

                // File completamente caricato, ottengo URL immagine in bas64
                reader.onload = (e) => {
                    const base64Image = e.target.result;
                    //console.log(base64Image); // Puoi fare ciò che vuoi con l'immagine in formato base64
                    const tempUrl = URL.createObjectURL(file);

                    currentBase64Photo.value = base64Image;

                    const currentPhoto = {
                        file: file,
                        base64: base64Image,
                        tmp_src: tempUrl,
                    };
                    userPhoto.value.push(currentPhoto);
                };

                reader.readAsDataURL(file);
            }
        }

        /* async function getPhoto(event) {
            loadingPhotos.value = true;
            console.log(event);

            if (event.target.files.length > 0) {
                const file = event.target.files[0];
                //console.log(file);

                const currentPhoto = {
                    file: file,
                    filepath: file.lastModified,
                    tmp_src: URL.createObjectURL(file),
                };

                photos.value.push(currentPhoto);
            }
            loadingPhotos.value = false;
        } */

        /************************************
         *
         * ! Remove base64 prefix
         *
         *************************************/
        function removeBase64Prefix(base64) {
            return base64.replace(/^data:image\/[a-z]+;base64,/, "");
        }

        /**
         * ! Create new spesa
         */
        async function creaSpesa() {
            const dataSpesa = moment(spesa.data_inizio).format("YYYY-MM-DD");

            //Se non ho data mostro errore
            if (!spesa.data) {
                openToast("La data della spesa è obbligatoria", "toast_danger");
                return;
            }
            //Importo maggiore di zero
            if (!spesa.importo || spesa.importo == 0) {
                openToast("L'importo della spesa deve essere maggiore di zero", "toast_danger");
                return;
            }

            sendingData.value = true;

            const data = new FormData();
            data.append("nota_spese_dipendente", dipendenteID); //logged user
            data.append("nota_spese_data", dataSpesa);
            if (spesa.descrizione) {
                data.append("nota_spese_descrizione", spesa.descrizione);
            }
            data.append("nota_spese_importo", spesa.importo);
            data.append("nota_spese_rimborsata", 0);
            data.append("nota_spese_stato", 1);
            if (spesa.categoria) {
                data.append("nota_spese_categoria", spesa.categoria);
            }
            /**
             * * Se ho caricato foto tolgo il prefisso base64 e la salvo
             */
            if (userPhoto.value.length) {
                /* const convertedPhoto = await conversioneFoto(userPhoto.value);
                photoToSave = convertedPhoto[0].data;
                data.append("nota_spese_foto_ricevuta", photoToSave); */
                const imageData = removeBase64Prefix(currentBase64Photo.value);
                data.append("nota_spese_foto_ricevuta", imageData);
            }
            /* Display the values
            for (const value of data.entries()) {
                console.log(value[0] + ", " + value[1]);
            }
            return; */

            apiSpese
                .saveSpesa(data)
                .then((response) => {
                    if (response.data.status == 8) {
                        openToast(response.data.message, "toast_danger");
                    } else {
                        const res = response.data.data[0];
                        successResponse.value = true;
                        closeModalOnSubmit(successResponse, res);
                    }
                })
                .catch((error) => {
                    //console.error(error);
                    openToast("Errore durante la creazione della nota spesa", "toast_danger");
                })
                .finally(() => {
                    console.log("fine creazione nota spesa");
                    sendingData.value = false;
                });
        }

        return {
            spesa,
            creaSpesa,
            closeModal,
            arrowBackOutline,
            showActionSheetPhotos,
            showActionSheet,
            userPhoto,
            trash,
            categories,
            sendingData,
            //Camera
            refInputButton,
            refFotoButton,
            triggerCameraButton,
            getPhoto,
        };
    },
});
</script>

<style scoped>
ion-toolbar {
    --background: #086fa3;
    --color: #ffffff;
}

/* New rules */
.page_content {
    width: 100%;
    position: relative;
    min-height: 100%;
    background: #f2f2f2;
    padding: 16px;
}

.fields {
    width: 100%;
    border-radius: 4px;
    /*padding: 10px;*/
    padding: 16px;
    box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1);
}
.field {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    margin-bottom: 8px;
}

.field_title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 4px;
    color: #6b7280;
}

ion-item {
    --padding-start: 0;
    --padding-end: 0;
    --highlight-height: 0;
    --ripple-color: transparent;
    --background-activated: transparent;
    --background-activated-opacity: 0;
    margin-bottom: 4px;
}
ion-datetime,
ion-select {
    max-width: 100%;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    --padding-start: 8px;
}

ion-input,
ion-textarea {
    --placeholder-color: #6b7280;
    --padding-start: 8px !important;
    --padding-end: 8px !important;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    margin-top: 0;
}

.btn_richiesta {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 20px;
    margin-bottom: 8px;
    text-align: center;
    box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1);
    background-color: #086fa3;
    color: #ffffff;
}
.btn_richiesta:disabled {
    opacity: 0.4;
}

.btn_foto {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
    background-color: #2ea1db;
    color: #ffffff;
    box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1);
    transition: all 0.15s ease-in;
}

ion-item {
    --padding-start: 0;
    --padding-end: 0;
    --padding-left: 0;
    --padding-right: 0;
    --inner-padding-end: 0;
}

/* Image rules */
.img_photo {
    position: relative;
    max-height: 300px;
}
.img_action {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #dc2626;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}
ion-button {
    --color: #ffffff;
}
</style>
